import { AlertCircle } from 'lucide-react';

export function SkeletonCard() {
  return (
    <div className="relative bg-gradient-to-br from-gray-200 to-gray-100 rounded-2xl p-8 shadow-xl overflow-hidden animate-pulse">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-32 h-32 bg-white rounded-full -translate-y-1/2 translate-x-1/2"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-white rounded-full translate-y-1/2 -translate-x-1/2"></div>
      </div>

      {/* Badge Skeleton */}
      <div className="relative mb-4">
        <div className="inline-block w-20 h-6 bg-gray-300 rounded-full"></div>
      </div>

      {/* Icon Skeleton */}
      <div className="relative mb-4">
        <div className="w-16 h-16 rounded-xl bg-gray-300"></div>
      </div>

      {/* Title Skeleton */}
      <div className="relative mb-2">
        <div className="h-6 bg-gray-300 rounded w-3/4"></div>
      </div>

      {/* Description Skeleton */}
      <div className="relative mb-4 space-y-2">
        <div className="h-4 bg-gray-300 rounded w-full"></div>
        <div className="h-4 bg-gray-300 rounded w-5/6"></div>
      </div>

      {/* Parent Category Skeleton */}
      <div className="relative mb-4">
        <div className="h-4 bg-gray-300 rounded w-1/2"></div>
      </div>

      {/* Button Skeleton */}
      <div className="relative w-full h-10 bg-gray-300 rounded-lg"></div>
    </div>
  );
}

export function ErrorCard() {
  return (
    <div className="relative bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-8 shadow-xl overflow-hidden border-2 border-red-200">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 right-0 w-32 h-32 bg-red-500 rounded-full -translate-y-1/2 translate-x-1/2"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-orange-500 rounded-full translate-y-1/2 -translate-x-1/2"></div>
      </div>

      {/* Icon */}
      <div className="relative mb-4 flex justify-center">
        <div className="w-16 h-16 rounded-xl bg-red-100 flex items-center justify-center">
          <AlertCircle className="w-8 h-8 text-red-500" />
        </div>
      </div>

      {/* Content */}
      <h3 className="relative text-gray-800 text-center mb-3 font-semibold">Unable to Load</h3>
      <p className="relative text-gray-600 text-sm text-center mb-6">
        More Experts to Onboard very soon.
      </p>

      {/* Message */}
      <div className="relative bg-white/60 backdrop-blur-sm rounded-lg p-4 text-center">
        <p className="text-xs text-gray-700 mb-2">
          <span className="font-semibold">👨 Our team is heavily working on it  </span>
        </p>
        <p className="text-xs text-gray-500">
          Stay tuned, Coming soon.
        </p>
      </div>
    </div>
  );
}